const Bottom: React.FC = () => (
  <div className="bg-blue px-2.5 py-5">
    <div className="md-gap-y-0 mx-auto flex w-full max-w-[1070px] flex-col items-center justify-center gap-y-5 md:flex-row md:items-end md:justify-between">
      <a
        href="https://adasitecompliancetools.com/ap.asp?h=SHRSPC"
        target="_blank"
        rel="noreferrer"
      >
        <img
          alt="ADA Site Compliance-Accessibility Policy"
          height="82"
          loading="lazy"
          src="//www.adasitecompliance.com/img/APolicy.png"
          width="150"
        />
      </a>
      <span className="text-sm text-white">
        &copy; 2024 ShirtSpace All Rights Reserved.
      </span>
    </div>
  </div>
);

export default Bottom;
